const selectDeviceInputs = state => state.data.deviceInputs

const DeviceInputDataStoreSelectors = {
  deviceInputs: selectDeviceInputs
}

export default DeviceInputDataStoreSelectors
